import React from "react";
import { graphql } from "gatsby";
import {mapEdgesToNodes} from "../../lib/helpers";
import SEO from "../../components/seo";
import Layout from "../../containers/layout";
import BlockText from "../../components/block-text";

export const query = graphql`
  query EsPrivacyQuery {
    privacy: allSanityEsPrivacy(sort: {order: DESC, fields: publishedAt}, limit: 1) {
      edges {
        node {
          title
          publishedAt(formatString: "d/m/yyyy")
          _rawBody
        }
      }
    }
  }
`;
const Politicadeprivacidad = props => {
  const { data } = props;
  const privacyNodes = (data || {}).privacy ? mapEdgesToNodes(data.privacy) : [];
  const language = 'es';
  const canonical = [
    {
      rel: "canonical",
      href: "https://crema.cm/es/politicas-de-privacidad/"
    },
    {
      rel: "alternate",
      href: "https://crema.cm/en/privacy/",
      hrefLang: 'en'
    },
    {
      rel: "alternate",
      href: "https://crema.cm/es/politicas-de-privacidad/",
      hrefLang: 'es'
    },
    {
      rel: "alternate",
      href: "https://crema.cm/en/privacy/",
      hrefLang: 'x-default'
    },
  ];
  const ogurl = "https://crema.cm/es/politicas-de-privacidad/";
  return (
    <Layout language={language}>
      <SEO 
        lang={language} 
        title="Politica de privacidad - Crema" 
        description="Politica de privacidad sobre Crema, la plataforma para freelancers y profesionistas independientes en español."
        canonical={canonical} 
        keywords="" 
        ogurl={ogurl} 
      />
      <div className="privacy-terms">
        <h1>{privacyNodes[0].title}</h1>
        <h3 className="updated">Actualizado: {privacyNodes[0].publishedAt}</h3>
        <BlockText blocks={privacyNodes[0]._rawBody} />
      </div>
    </Layout>
  );
};

export default Politicadeprivacidad;
